import { portalPaths, UrlSegments } from '@provision/portal-routes';
import { useCallback } from 'react';
import { Conversation, RecordOpenMode } from 'src/graphql';
import { useRecordOpenMode } from 'src/graphql/entities/record-open-mode/record-open-mode';
import { EntityNames } from 'src/graphql/types';
import { ConversationsViewInner } from 'src/pages/Conversations';
import { useSelectedEntityParams } from 'src/pages/CustomViews/custom-views-selected-view/hooks/use-selected-entity-params';
import { useNavigateRoute } from 'src/utils/routing/use-navigate-route';
import { useScreenDimensions } from 'src/utils/system';

export const ConversationSelectedView = () => {
  const { navigate } = useNavigateRoute();
  const { isMobile } = useScreenDimensions();

  const {
    recordId: conversationFriendlyId,
    record,
    customView,
    viewId,
    openRecord,
    closeRecord,
    selectedCustomViewId,
  } = useSelectedEntityParams({ entityName: EntityNames.Conversation });

  const { currentOpenMode } = useRecordOpenMode();

  const handleConversationClick = useCallback(
    (rawId: string, conversation?: Conversation) => {
      const id = conversation ? conversation.friendlyId : rawId;

      if (!isMobile && currentOpenMode === RecordOpenMode.FullPage) {
        navigate(portalPaths.conversation.full(id), {
          state: { customViewId: customView?.customViewId },
        });
      } else {
        openRecord(id);
      }
    },
    [currentOpenMode, customView?.customViewId, isMobile, navigate, openRecord],
  );

  return (
    <ConversationsViewInner
      title={selectedCustomViewId === UrlSegments.view.all ? 'All conversations' : ''}
      customView={customView}
      viewId={viewId}
      conversationFriendlyId={conversationFriendlyId}
      conversationId={record?.id}
      handleConversationClick={handleConversationClick}
      onCloseConversation={closeRecord}
    />
  );
};
